<template>
  <v-container class="d-flex align-center mt-n2" fluid>
    <div class="mr-7">
      <h1 class="d-flex justify-center" :style="`color: #${titleColor}`">{{ displayDays }}</h1>
      <p class="d-flex justify-center" :style="`color: #${textColor}`">{{ $t('days') }}</p>
    </div>
    <div class="mr-5">
      <h1 class="d-flex justify-center" :style="`color: #${titleColor}`">{{ displayHours }}</h1>
      <p class="d-flex justify-center" :style="`color: #${textColor}`">{{ $t('hours') }}</p>
    </div>
    <div class="mr-5">
      <h1 class="d-flex justify-center" :style="`color: #${titleColor}`">{{ displayMinute }}</h1>
      <p class="d-flex justify-center" :style="`color: #${textColor}`">{{ $t('minutes') }}</p>
    </div>
    <div>
      <h1 class="d-flex justify-center" :style="`color: #${titleColor}`">{{ displaySeconds }}</h1>
      <p class="d-flex justify-center" :style="`color: #${textColor}`">{{ $t('seconds') }}</p>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Counter",
  props: {
    endTime: Date,
    titleColor: String,
    textColor: String,
  },
  data() {
    return {
      displaySeconds: 0,
      displayMinute: 0,
      displayHours: 0,
      displayDays: 0,
    };
  },
  computed: {
    _seconds: () => 1000,
    _minutes() {
      return this._seconds * 60;
    },
    _hours() {
      return this._minutes * 60;
    },
    _days() {
      return this._hours * 24;
    },
  },
  mounted() {
    this.showRemaining();
  },
  methods: {
    showRemaining() {
      const timer = setInterval(() => {
        let now = new Date();
        let distance = this.endTime.getTime() - now.getTime();
        if(distance < 0) {
          clearInterval(timer);
          return;
        }

        let days = Math.floor(distance / this._days);
        let hours = Math.floor((distance % this._days) / this._hours);
        let mins = Math.floor((distance % this._hours) / this._minutes);
        let secs = Math.floor((distance % this._minutes) / this._seconds);
        this.displayDays = (days < 10)? `0${days}` : days;
        this.displayHours = (hours < 10)? `0${hours}` : hours;
        this.displayMinute = (mins < 10)? `0${mins}` : mins;
        this.displaySeconds = (secs < 10)? `0${secs}` : secs;
      }, 1000);
    },
  }
}
</script>

<i18n>
{
  "en": {
    "days": "Days",
    "hours": "Hours",
    "minutes": "Minutes",
    "seconds": "Seconds"
  },
  "es": {
    "days": "Días",
    "hours": "Horas",
    "minutes": "Minutos",
    "seconds": "Segundos"
  }
}
</i18n>

<style scoped>

</style>
